import React, { useState } from 'react';
import { Box, IconButton, CardMedia } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import COLORS from '../../../../Utils/colors';

interface Props {
  images: { fileURL?: string }[];
  height?: number;
}

const ImageCarousel: React.FC<Props> = ({ images, height = 220 }) => {
  const [index, setIndex] = useState(0);
  if (!images?.length) return null;

  const prev = () =>
    setIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () =>
    setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <Box sx={{ position: 'relative', height, overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          width: `${images.length * 100}%`,
          transform: `translateX(-${index * (100 / images.length)}%)`,
          transition: 'transform 0.3s ease',
        }}
      >
        {images.map((img, i) => (
          <CardMedia
            key={i}
            component="img"
            image={img.fileURL}
            sx={{ width: '100%', height, objectFit: 'cover' }}
          />
        ))}
      </Box>

      {images.length > 1 && (
        <>
          <IconButton onClick={prev} sx={navStyle('left')}>
            <ArrowBackIos fontSize="small" />
          </IconButton>
          <IconButton onClick={next} sx={navStyle('right')}>
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        </>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, gap: 1 }}>
        {images.map((_, i) => (
          <Box
            key={i}
            onClick={() => setIndex(i)}
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              cursor: 'pointer',
              bgcolor: i === index ? COLORS.primary : 'rgba(0,0,0,.3)',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

const navStyle = (side: 'left' | 'right') => ({
  position: 'absolute',
  top: '50%',
  [side]: 8,
  transform: 'translateY(-50%)',
  bgcolor: 'rgba(0,0,0,.5)',
  color: 'white',
  width: 32,
  height: 32,
});

export default React.memo(ImageCarousel);
